import { InjectionToken } from '@angular/core';
import { Observable } from 'rxjs';

export const BUTTON_PARENT = new InjectionToken<ButtonParent>('BUTTON_PARENT');

export interface ButtonParent {
  getActive(value: any): Observable<boolean>;
  toggleValue(value: any): void;
}
